/**
 * createCollectionState
 *
 * Pure Valtio state for a collection of documents.
 *
 * The `docs` map and `docIds` array it returns are the containers consumers
 * subscribe to for the store's whole lifetime. Reset paths must empty them in
 * place; see the `CollectionState` invariant in `Store.types.ts`.
 */

import { proxy } from 'valtio';
import { proxyMap } from 'valtio/utils';
import type { CollectionState, DocEntry } from '../Store.types';

/**
 * Creates a Valtio reactive state for a collection.
 */
export function createCollectionState<
  T extends Record<string, unknown>,
>(): CollectionState<T> {
  const docs = proxyMap<string, DocEntry<T>>();

  return proxy<CollectionState<T>>({
    loading: true,
    docs,
    docIds: [],
  });
}
